import { $Qll } from '../utils/query-selector'
import { $Q } from '../utils/querySelector'

export const selectTabs = (accordionsParam, contentParam) => {
  const accordions = $Qll(accordionsParam)
  const content = $Qll(contentParam)
  let activeAccordion = null

  const fatherTab = $Qll('.menu-component__submenu-list.js-submenu-list-component')

  fatherTab.forEach((validacion) => {
    const currentTag = $Q('.first-level', validacion)
    if (!currentTag) return;

    currentTag.setAttribute('tabindex', '0');
    currentTag.setAttribute('role', 'button');
    currentTag.setAttribute('aria-expanded', 'false');

    const activateTab = (e) => {
      e.preventDefault();

      accordions.forEach((elemento) => {
        elemento.classList.remove('isSelected');
        elemento.setAttribute('aria-expanded', 'false');
      });

      currentTag.classList.add('isSelected');
      currentTag.setAttribute('aria-expanded', 'true');

      activeAccordion = currentTag.dataset.index;

      content.forEach((contenedor) => {
        if (contenedor.dataset.index === activeAccordion) {
          contenedor.classList.add('isSelected');
          contenedor.removeAttribute('hidden');
          contenedor.setAttribute('tabindex', '-1');

          requestAnimationFrame(() => {
            contenedor.focus();
          });
        } else {
          contenedor.classList.remove('isSelected');
          contenedor.setAttribute('hidden', true);
        }
      });
    };

    currentTag.addEventListener('click', activateTab);

    currentTag.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        activateTab(e);
      }
    });
  })
}
